import { createAction } from '@reduxjs/toolkit';
import { createReduxActionCreator } from '../types';
import { LLMPrompt } from './llmPromptsTypes';

export const LLM_PROMPTS_ACTION_PREFIX = 'llm-prompts-redux/';

export const getLLMPromptsActions = createReduxActionCreator<LLMPrompt[]>(`${LLM_PROMPTS_ACTION_PREFIX}get-llm-prompts`);
export const getLLMPromptByIdActions = createReduxActionCreator<LLMPrompt>(`${LLM_PROMPTS_ACTION_PREFIX}get-llm-prompt-by-id`);
export const createLLMPromptActions = createReduxActionCreator<LLMPrompt>(`${LLM_PROMPTS_ACTION_PREFIX}create-llm-prompt`);
export const updateLLMPromptActions = createReduxActionCreator<LLMPrompt>(`${LLM_PROMPTS_ACTION_PREFIX}update-llm-prompt`);
export const deleteLLMPromptActions = createReduxActionCreator<string>(`${LLM_PROMPTS_ACTION_PREFIX}delete-llm-prompt`);

export const clearLLMPromptsErrorAction = createAction<undefined>(`${LLM_PROMPTS_ACTION_PREFIX}clear-error`);
export const clearLLMPromptsSuccessAction = createAction<undefined>(`${LLM_PROMPTS_ACTION_PREFIX}clear-success`);
